import React from "react";
import { Link } from "react-router-dom";
import { buildAlertSentence } from "./alert-utils";
import { ALERT_STATUS } from "./alert-types";

export default function AlertHistoryModal({ open = false, alerts = [], onClose = () => {} }) {
  if (!open) {
    return null;
  }

  return (
    <div className="alert-history-modal" role="dialog" aria-modal="true">
      <div className="alert-history-modal__backdrop" onClick={onClose} />
      <div className="alert-history-modal__panel">
        <div className="alert-history-modal__head">
          <div>
            <span>ALERT HISTORY</span>
            <h2>이상 알림 내역</h2>
          </div>
          <button type="button" onClick={onClose}>닫기</button>
        </div>
        <div className="alert-history-modal__list">
          {!alerts.length ? (
            <p className="alert-history-modal__empty">표시할 알림 이력이 없습니다.</p>
          ) : (
            alerts.map((item) => (
              <article key={item.id} className="alert-history-modal__item">
                <div className="alert-history-modal__item-head">
                  {item.detail_url ? (
                    <Link to={item.detail_url} className="alert-card__link">
                      {item.device_display_key || item.item_name || item.device_name || item.device_key}
                    </Link>
                  ) : (
                    <strong>{item.device_display_key || item.item_name || item.device_name || item.device_key}</strong>
                  )}
                  <em>{item.status === ALERT_STATUS.ALERT ? "미확인" : "확인됨"}</em>
                </div>
                <p>{buildAlertSentence(item)}</p>
                <small>{item.detected_at || "-"}</small>
              </article>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
